import { AiChatSuggestion } from "./AiChat.types";
import { ContractFilterStatus } from "../contract/Contracts.types";
import { ContractColumn } from "../contract/contractDisplayFields/ContractDisplayFields.types";
import { ListFilterOperator, SortDirection } from "../common/api/filterTypes";
import { DateFieldFilterEnum } from "../common/components/filterPopover/subMenues/DateFieldSubMenu";
import TearOffCalendarIcon from "./assets/tearOffCalendar.svg?react";
import ChartIncreasingIcon from "./assets/chartIncreasing.svg?react";
import MagnifyingGlassIcon from "./assets/magnifyingGlass.svg?react";

// Each chip stages a deterministic SQL pre-filter plus a verb-matched prompt. The sortByColumn
// on each filter signals to AiChatHandler.ResolveContractScope that the caller wants its sort +
// page size honored (instead of the legacy ModifiedDate-DESC top-400). Page sizes are tuned to
// the verb band (≤10 coverage, 11-30 light coverage, 31-80 discovery) — see memory
// ai-chat-scope-retrieval-honesty for rationale.
export const defaultSuggestions: AiChatSuggestion[] = [
    {
        labelKey: "aiChatSuggestionExpiringSoonLabel",
        promptKey: "aiChatSuggestionExpiringSoonPrompt",
        icon: TearOffCalendarIcon,
        scope: {
            contracts: {
                status: { value: [ContractFilterStatus.Approved], filterOperator: ListFilterOperator.In },
                endDateRange: { dateFieldEnum: DateFieldFilterEnum.NextThreeMonths },
                sortByColumn: ContractColumn.EndDate,
                sortDirection: SortDirection.ASC,
                pageSize: 15,
            },
        },
    },
    {
        labelKey: "aiChatSuggestionHighValueLabel",
        promptKey: "aiChatSuggestionHighValuePrompt",
        icon: ChartIncreasingIcon,
        scope: {
            contracts: {
                status: { value: [ContractFilterStatus.Approved], filterOperator: ListFilterOperator.In },
                // Exclude contracts with NULL TotalAmount. SQL Server sorts NULLs last under
                // DESC, so without this filter the page fills with arbitrary NULL-amount
                // contracts once the real high-value ones run out — the LLM then talks about
                // them as if they were "highest-value", which they aren't.
                totalAmount: { from: 1 } as unknown as never,
                sortByColumn: ContractColumn.TotalAmount,
                sortDirection: SortDirection.DESC,
                pageSize: 10,
            },
        },
    },
    {
        labelKey: "aiChatSuggestionRiskSweepLabel",
        promptKey: "aiChatSuggestionRiskSweepPrompt",
        icon: MagnifyingGlassIcon,
        scope: {
            contracts: {
                status: { value: [ContractFilterStatus.Approved], filterOperator: ListFilterOperator.In },
                totalAmount: { from: 1 } as unknown as never,
                sortByColumn: ContractColumn.TotalAmount,
                sortDirection: SortDirection.DESC,
                pageSize: 30,
            },
        },
    },
];
